import { defaultRegionInfoProvider } from "./endpoints";
export var ClientSharedValues = {
    apiVersion: "2006-03-01",
    disableHostPrefix: false,
    signingName: "s3",
    regionInfoProvider: defaultRegionInfoProvider,
    signingEscapePath: false
};
//# sourceMappingURL=runtimeConfig.shared.js.map